module.exports = "pegasus/assets/theme5/twitter-icon-1.png";